export default __webpack_public_path__ + "static/media/2243.31810141.svg";